export enum VerificationStatusEnum {
  "pending" = 1,
  "accepted" = 2,
  "rejected" = 3,
}